// class for defining the amzn user-agent
export default UserAgent;
// constructor
function UserAgent() {}
// public
UserAgent.prototype.userAgent = 'aws-amplify/0.1.x js';


//////////////////
// WEBPACK FOOTER
// ./node_modules/amazon-cognito-identity-js/es/UserAgent.js
// module id = 1197
// module chunks = 10